import React, { useCallback, useContext, useReducer } from "react";
import { MessageActionKind } from "../interfaces";
import UploadAssetsForm from "../UploadAssetsForm/UploadAssetsForm";
import LoadedMedia from "../LoadedMedia/LoadedMedia";
import { MESSAGE_CONFIG } from "../../../constents";
import SocketContext from "../../../providers/Socket";
import useTranslation from "../../../hooks/use-translation";
import { isDeviceMobile } from "../../../libs/auth.helper";
const DEFAULT_STATE = {
    content: '',
    progress: 0,
    type: null,
    validation: {
        valid: true,
        message: ''
    }
};
const reducer = (state, action) => {
    switch (action.type) {
        case MessageActionKind.SET_ERROR:
            return Object.assign(Object.assign({}, state), { content: state.content, progress: 0, validation: {
                    valid: false,
                    message: action.payload.message
                } });
        case MessageActionKind.SET_CONTENT:
            return Object.assign(Object.assign({}, state), { content: action.payload.content, progress: action.payload.progress || 100, type: action.payload.type || "text", validation: {
                    valid: true,
                    message: ''
                } });
        case MessageActionKind.UPDATE_PROGRESS:
            return Object.assign(Object.assign({}, state), { content: state.content, progress: action.payload.progress, validation: {
                    valid: true,
                    message: ''
                } });
        case MessageActionKind.CLEAR:
            return DEFAULT_STATE;
        default:
            return Object.assign({}, state);
    }
};
const SendMessageForm = (props) => {
    const { sendMessageHandler, chat } = props;
    const [state, dispatch] = useReducer(reducer, DEFAULT_STATE);
    const { socket } = useContext(SocketContext);
    const { translate } = useTranslation();
    const emitIsTyping = useCallback(function () {
        var _a, _b, _c;
        if (!socket)
            return;
        socket === null || socket === void 0 ? void 0 : socket.emit("typing", (_a = chat.details) === null || _a === void 0 ? void 0 : _a.pid, (_b = chat.details) === null || _b === void 0 ? void 0 : _b.oid, (_c = chat.details) === null || _c === void 0 ? void 0 : _c.rooms[0].uid);
    }, [socket]);
    const onSend = () => {
        const text = state === null || state === void 0 ? void 0 : state.content.trim();
        if (!text)
            return;
        const data = {
            text,
            type: MESSAGE_CONFIG.TYPES.MESSAGE_TYPE_TEXT,
            subType: MESSAGE_CONFIG.SUB_TYPES.TEXT_FROM_NORMAL,
        };
        sendMessageHandler(Object.assign({}, data)).then(() => {
            dispatch({
                type: MessageActionKind.CLEAR
            });
        });
    };
    const onInputChange = (e) => {
        dispatch({
            type: MessageActionKind.SET_CONTENT,
            payload: {
                content: e.target.value
            }
        });
        emitIsTyping();
    };
    const LoadedContent = () => {
        if (!state.content || state.type !== "media")
            return React.createElement(React.Fragment, null);
        return (React.createElement(LoadedMedia, { url: state.content, progress: state.progress }));
    };
    const handleKeyDown = (e) => {
        if (!isDeviceMobile() && e.key === "Enter" && !e.shiftKey)
            onSend();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(LoadedContent, null),
        React.createElement("div", { className: 'sendMessageForm__footer', id: 'kt_drawer_chat_messenger_footer' },
            React.createElement("div", { className: 'd-flex align-items-center' },
                React.createElement(UploadAssetsForm, { sendMessageHandler: sendMessageHandler, dispatch: dispatch })),
            React.createElement("textarea", { className: 'form-control form-control-flush mb-3 sendMessageForm__footer-textarea', rows: 1, "data-kt-element": 'input', placeholder: translate("message-text"), onChange: onInputChange, onKeyDown: handleKeyDown, autoFocus: true, disabled: props.isBlocked, value: state.type === "text" ? state.content : "" }),
            React.createElement("div", { className: 'd-flex flex-stack' },
                React.createElement("button", { className: 'btn btn-primary sendMessageForm__footer-button-send', type: 'button', "data-kt-element": 'send', disabled: props.isBlocked, onClick: onSend },
                    React.createElement("i", { className: "fa-solid fs-1 fa-paper-plane" }))))));
};
export default SendMessageForm;
